import React from "react";
import { Box } from "@mui/material";

export const Logo = ({ logoURL }) => {
  return (
    <Box>
      <img
        src={!!logoURL ? logoURL : "/img/logo.svg"}
        style={{ width: "120px" }}
        alt="Org logo"
      />
    </Box>
  );
};
